(() => {
  if (customElements.get('tiles-carousel')) {
    return;
  }

  class TilesCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
    }

    initElements() {
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      };
      this.sliderType = '';
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('tiles-carousel', TilesCarousel);
})();
